// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2SuWH","header":"ReportDetails_header__LP8jH","title":"ReportDetails_title__3oL2N","left":"ReportDetails_left__EMiD4"};